/* ============
 * License Permit Type Transformer
 * ============
 *
 * The transformer for the licensePermitType.
 */

import Transformer from './transformer';

export default class licensePermitTypeTransformer extends Transformer {

  static fetch(licensePermitType) {
    return {
      id: licensePermitType.id,
      licenseTypeId: licensePermitType.license_type_id,
      code: licensePermitType.code,
      name: licensePermitType.name,
      description: licensePermitType.description,
    };
  }

  static send(licensePermitType) {
    return {
      id: licensePermitType.id,
      name: licensePermitType.name,
      description: licensePermitType.description,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/licensePermitType.js